// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS } from 'immutable';
import constants from './BundleTracker.constants';

const initialState = fromJS({
  isTrackerOpen: false,
  bundleData: [],
});

const bundleReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.TOGGLE_TRACKER:
      return state.set('isTrackerOpen', payload);
    case constants.SET_BUNDLE_DATA:
      return state.set('bundleData', payload);
    default:
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
};

export default bundleReducer;
